import { text } from '@modules/forgot-password/text';
import type { FormEvent } from 'react';

import type { ForgotPasswordFormCopy, ForgotPasswordStep } from './models';
import { text as featureText } from './text_business_logic';

export type { ForgotPasswordFormCopy, ForgotPasswordStep } from './models';

export function getForgotPasswordFormCopy(
  step: ForgotPasswordStep,
  isSubmitting: boolean
): ForgotPasswordFormCopy {
  return featureText.forgotPasswordFormCopy(step, isSubmitting);
}

export function getForgotPasswordVerifyErrorMessage(error: Error): string {
  return error.message.includes('Invalid password') ? text.verifyInvalidPassword : text.verifyError;
}

export function createForgotPasswordFormSubmitHandler(onSubmit: () => void) {
  return (event: FormEvent) => {
    event.preventDefault();
    onSubmit();
  };
}
